import React from 'react';
import {Table} from '@/web-components';
import Util from '../../../../shared/util/util';
import {getQueryRenderer} from '../TimeRegistrationReportPageUtil';
import {getCurrencyCell, getGroupedRowColumns} from '../TimeRegistrationReportTableUtil';
import {GLOBAL_FILTER_FIELD, GLOBAL_FILTER_OPERATOR} from '../../../../../constants';

export const getRoleRow = (
	data,
	intl,
	groupIndex,
	searchQuery,
	groupings,
	enabledColumns,
	hasNextPage,
	fetchMore,
	nextLevelProps,
	currency,
	reportId,
	sharedId,
	customFieldDefinitions,
	customFieldKeys
) => {
	const getColumns = role =>
		getGroupedRowColumns(
			{
				label: <span>{role.noRole ? intl.formatMessage({id: 'time_reg_report.no_role'}) : role.name}</span>,
				actualHours: Util.convertMinutesToFullHour(role.timeRegTotals?.totalTimeRegistered, intl, true),
				billableHours: Util.convertMinutesToFullHour(role.timeRegTotals?.totalBillableRegistered, intl, true),
				nonBillableHours: Util.convertMinutesToFullHour(role.timeRegTotals?.totalNonBillableRegistered, intl, true),
				actualBillableValueOfService: getCurrencyCell(role.timeRegTotals?.totalPrice, currency, intl),
				actualCost: getCurrencyCell(role.timeRegTotals?.totalCost, currency, intl),
			},
			customFieldDefinitions
		);

	return (
		<Table.Rows data={data} canExpand={true} loadMore={hasNextPage && fetchMore} {...nextLevelProps}>
			{({rowData, tableColumnsProps, nextLevelProps, expanded}) => {
				const filterField =
					rowData.noRole === true ? GLOBAL_FILTER_FIELD.NON_ROLE_TIME_REG : GLOBAL_FILTER_FIELD.ROLE_TIME_REG;
				return (
					<>
						<Table.Row {...tableColumnsProps}>{getColumns(rowData)}</Table.Row>
						{expanded &&
							getQueryRenderer(
								null,
								groupings,
								searchQuery,
								groupIndex,
								enabledColumns,
								{field: filterField, operator: GLOBAL_FILTER_OPERATOR.IS, value: [rowData.roleId]},
								nextLevelProps,
								currency,
								reportId,
								sharedId,
								customFieldDefinitions,
								customFieldKeys
							)}
					</>
				);
			}}
		</Table.Rows>
	);
};
